// extracted by mini-css-extract-plugin
export default {"pageLink":"Z_cS"};